<template>
  <view class="small-package-wrapper" bindtap="clickExtra">
    <view class="lighting-icon-wrapper" />
    <image wx:if="{{firstSee}}" class="new-icon" src="https://ut-static.udache.com/webx/sfc/cklKfatdT5bxrnRTTic6q.png" />
    <view wx:if="{{amount}}" class="top-area">
      <text class="amount">{{ amount }}</text>
      <text class="unit">个</text>
    </view>
    <view class="bottom-area">
      <text wx:if="{{name}}" class="name">{{ name }}</text>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { getStorage } from '@/utils/storage'
  import { NOT_FIRST_SEEN_ACC_PACK } from '@/utils/train-storage'

  createComponent({
    props: {
      couponData: {
        type: Object,
        value: () => {}
      }
    },
    computed: {
      amount() {
        return this.couponData?.coupon_info?.amount ?? 0
      },
      name() {
        return this.couponData?.coupon_info?.name ?? ''
      },
      firstSee() {
        return !getStorage(NOT_FIRST_SEEN_ACC_PACK)
      }
    },
    methods: {
      clickExtra() {
        this.triggerEvent('clickExtra', 'package')
      }
    }
  })
</script>

<style scoped lang="stylus">
  .small-package-wrapper
    flex 1
    display flex
    flex-direction column
    align-items center
    justify-content center
    margin-right 10px
    border-radius 8px
    background #FFF7E6
    border 0.75px solid rgba(255, 89, 0, 0.4)
    box-sizing border-box
    position relative
    .new-icon
      position absolute
      height 17px
      width 33px
      z-index 3
      top -6.5px
      left 0px
    &:last-child
      margin-right 0
    .top-area
      z-index 2
      .amount, .unit
        font-weight 600
        color #FF5900
      .amount
        font-family Barlow Semi Condensed
        font-size 24px
        font-weight 400
      .unit
        font-family PingFang SC
        line-height 11px
    .bottom-area
      z-index 2
      font-size 9px
      font-weight 400
      color #B38369
      max-width 90%
      overflow hidden
      text-overflow ellipsis
      line-height 15px
      .name
        white-space nowrap
        font-family PingFang SC
    .lighting-icon-wrapper
      z-index 1
      position absolute
      width 100%
      height 100%
      left 0
      top 0
      border-radius 8px
      overflow hidden
      &::after
        content ''
        position absolute
        width: 26.5px;
        height: 38.5px
        bottom -5px
        right -1.5px
        background-image url('https://ut-static.udache.com/webx/sfc/ZoccEWWoIAb5F4qQt09A6.png')
        background-size cover
</style>

<script name="json">
    module.exports = {
      component: true,
      usingComponents: {}
    }
</script>